import {dispatchEvent} from "../../utils/eventDispatch";

/**
 * Carga Highcharts e importa los módulos necesarios.
 * Devuelve la promesa del módulo HighCharts cargado.
 * @return {Promise<Highcharts>}
 */
export const loadHighCharts = async () => {
    const Highcharts = await import("highcharts/highstock")

    // El gráfico de Potencial Objetivo requiere highcharts-more y gauge
    const potencialObjetivoDiv = document.querySelector('.gauge-chart-container');
    if (potencialObjetivoDiv) {
        const HighchartsMore = await import('highcharts/highcharts-more');
        const HighCartsGauge = await import('highcharts/modules/solid-gauge');
        HighchartsMore.default(Highcharts);
        HighCartsGauge.default(Highcharts);
    }

    //El gráfico de Tendencias requiere algunos plugins más

    const tendencialDiv = document.querySelector('.stacked-chart-container');
    if (tendencialDiv) {
        const HC3d = await import('highcharts/highcharts-3d');
        const HCExporting = await import('highcharts/modules/exporting');
        const HCExportingData = await import('highcharts/modules/export-data');
        HC3d.default(Highcharts);
        HCExporting.default(Highcharts);
        HCExportingData.default(Highcharts);
    }


    window.Highcharts = Highcharts;
    dispatchEvent('HighChartsLoaded');
    return Highcharts;
}
